import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-703eb3aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text"
}
const _hoisted_2 = {
  key: 1,
  class: "text"
}

import { computed } from "vue";
import store from "@/store";
import tableBox from "./tableBox.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'howToGetScore',
  setup(__props) {

const dialogVisible = computed(() => {
  return store.state.howToGetScoreState;
});
const appLanguage: any = computed(() => store.getters.getAppLanguage);

const changeStage = () => {
  store.commit("howToGetScoreState", false);
};

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(dialogVisible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
    title: _ctx.$t('pointsMall.how'),
    "before-close": changeStage,
    "custom-class": "howGetToSocre",
    "destroy-on-close": "true"
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      (_unref(appLanguage) == 'en')
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t("pointsMall.text")), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("pointsMall.text")), 1)),
      _createVNode(tableBox)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})